


























































































import CtrlAddBtn from '@/components/common/control/CtrlAddBtn.vue';
import CtrlClearBtn from '@/components/common/control/CtrlClearBtn.vue';
import CtrlDatePicker from '@/components/common/control/CtrlDatePicker.vue';
import CtrlMessageDialog from '@/components/common/control/CtrlMessageDialog.vue';
import CtrlResetBtn from '@/components/common/control/CtrlResetBtn.vue';
import G_090_ZaikoIdoIraiEntry_ChildHeaderInput from '@/components/G_kaigai/G_090_ZaikoIdoIraiEntry_ChildHeaderInput.vue';
import G_090_ZaikoIdoIraiEntry_Table from '@/components/G_kaigai/G_090_ZaikoIdoIraiEntry_Table.vue';
import { Flg, OutStatus, ShoriKb } from '@/constants/constants';
import { BUTTON } from '@/constants/label';
import { dateNumToStr, dateStrToNum } from '@/utils/utils';
import moment from 'moment';
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend<any, any, any, any>({
  name: 'G_090_ZaikoIdoIraiEntry',
  components: {
    CtrlMessageDialog,
    CtrlResetBtn,
    CtrlClearBtn,
    CtrlAddBtn,
    CtrlDatePicker,
    G_090_ZaikoIdoIraiEntry_ChildHeaderInput,
    G_090_ZaikoIdoIraiEntry_Table,
  },
  data: () => ({
    BUTTON,

    zaikoIdoIraiEntryYmdF: '',
    zaikoIdoIraiEntryYmdT: '',
    search: '',
    kakuteiFlg: false,
    items: [],
    ShoriKb,
    shoriKb: ShoriKb.ADD,
    childHeaderInputItem: {},
    childHeaderInputShow: false,
    messageShow: false,
    messageId: '',
    messageTextParam: [],
    isClearTable: false,
  }),
  computed: {
    ...mapGetters({
      userInfo: 'common/userInfo',
    }),
    itemsDisp() {
      return this.kakuteiFlg
        ? this.items
        : this.items.filter((item: any) => item.kakuteiFlg === Flg.FLG_FALSE);
    },
  },
  methods: {
    initValues() {
      this.items = [];
      this.zaikoIdoIraiEntryYmdF =
        this.userInfo &&
        this.userInfo.onlineData &&
        moment(this.userInfo.onlineData.genzaiYmd.toString())
          .subtract(1, 'month')
          .format()
          .substring(0, 10);
      this.zaikoIdoIraiEntryYmdT = moment(
        this.userInfo.onlineData.genzaiYmd.toString()
      )
        .format()
        .substring(0, 10);
      this.search = '';
      this.kakuteiFlg = false;
    },
    async handleReset() {
      if (await this.checkValidate()) {
        this.items = [];
        this.getData();
      }
    },
    handlClear() {
      this.initValues();
    },
    handleOkMessage() {
      if (this.messageId == 'KI_W123') {
        window.location.href = '/';
      }
      this.messageId = '';
      this.messageTextParam = [];
      this.messageShow = false;

      if (this.isClearTable) {
        this.isClearTable = false;
        this.items = [];
      }
    },
    handleAdd() {
      this.childHeaderInputItem = {
        zaikoIdoIraiEntryYmd: this.userInfo.onlineData.genzaiYmd,
        zaikoIdoIraiJigyoshoCd: this.userInfo.jigyoshoData.jigyoshoCd,
      };
      this.shoriKb = ShoriKb.ADD;
      this.childHeaderInputShow = true;
    },
    handleInfo(item: any) {
      this.childHeaderInputItem = item;
      this.shoriKb = ShoriKb.REFER;
      this.childHeaderInputShow = true;
    },
    handleEdit(item: any) {
      this.childHeaderInputItem = item;
      this.shoriKb = ShoriKb.UPD;
      this.childHeaderInputShow = true;
    },
    handleChildHeaderInputHide(reload: boolean) {
      if (reload) {
        this.items = [];
        this.getData();
      }
    },
    async checkValidate() {
      await new Promise((resolve) => setTimeout(resolve, 300));
      this.$refs.form.validate();

      if (
        !dateStrToNum(this.zaikoIdoIraiEntryYmdF) ||
        !dateStrToNum(this.zaikoIdoIraiEntryYmdT)
      ) {
        this.messageId = 'KI_W100';
        this.messageTextParam = ['依頼日'];
        this.messageShow = true;
        return;
      }
      if (
        this.zaikoIdoIraiEntryYmdF &&
        this.zaikoIdoIraiEntryYmdT &&
        dateStrToNum(this.zaikoIdoIraiEntryYmdF) >
          dateStrToNum(this.zaikoIdoIraiEntryYmdT)
      ) {
        this.messageId = 'KI_W101';
        this.messageTextParam = ['依頼日'];
        this.messageShow = true;
        return;
      }
      if (!this.$refs.form.validate()) {
        this.messageId = 'KI_W121';
        this.messageTextParam = [];
        this.messageShow = true;
        return;
      }
      return true;
    },
    async getData() {
      this.$store.dispatch('common/setIsLoading', true);
      const params = {
        zaikoIdoIraiJigyoshoCd: this.userInfo.jigyoshoData.jigyoshoCd,
        zaikoIdoIraiEntryYmdF: dateStrToNum(this.zaikoIdoIraiEntryYmdF),
        zaikoIdoIraiEntryYmdT: dateStrToNum(this.zaikoIdoIraiEntryYmdT),
      };
      const res = await this.$store.dispatch(
        'g090/getZaikoIdoIraiEntry',
        params
      );
      this.$store.dispatch('common/setIsLoading', false);

      if (
        res &&
        res.status == 200 &&
        res.data &&
        res.data.error &&
        res.data.error.outStatus &&
        res.data.error.outStatus != OutStatus.NORMAL
      ) {
        const { error } = res.data;
        this.messageShow = true;
        this.messageId = error.messageID;
        this.messageTextParam = error.messageArgs;
        this.isClearTable = true;
        return;
      }

      this.items = res.data.responseData
        ? res.data.responseData.map((item: any) => ({
            ...item,
            zaikoIdoIraiEntryYmd: dateNumToStr(item.zaikoIdoIraiEntryYmd),
          }))
        : [];
    },
  },
  created() {
    if (!this.userInfo.shiiresakiCd) {
      this.messageId = 'KI_W123';
      this.messageTextParam = ['利用者マスタの仕入先が未設定の', '実行'];
      this.messageShow = true;
      return;
    }
    this.initValues();
  },
});
